import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-judentum-zuhause',
  templateUrl: './judentum-zuhause.component.html',
  styleUrls: ['./../app.component.css']
})
export class JudentumZuhauseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
